<template>
  <div class="login-container">
    <div class="login-bg" v-show="!isPad">
      <img src="../images/lenovo.png" alt="" v-if="changeLogo"/>
      <img src="../images/1366-bg.png" alt="" v-else/>
      <img v-if="logoUrl !== ''" :src="logoUrl" alt="" class="logo">
      <div class="adaptive" :class="{'noImg':!logoUrl}">智适应教学平台</div>
    </div>

    <!-- 登录表单 -->
    <div class="form-wrap">
      <div class="login-log">
        <span>登录LOGIN</span>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="uname">
          <div class="login-user">
            <img src="../images/user.png" alt="" />
          </div>
          <el-input
            v-model="loginForm.uname"
            placeholder="请输入登录账号"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <div class="login-pass">
            <img src="../images/me.png" alt="" />
          </div>
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            class="top"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <!-- 登录按钮 -->
      <div class="form-foot">
        <el-button type="primary" round v-debounce="submitLogin"
          >登 录</el-button
        >
      </div>
      <!-- 提醒 -->
      <div class="login-remind">
        <!-- <img src="../images/dengpao.png" alt="" />
        <span>  如果忘记了账号/密码，可以联系班主任找回</span> -->
        <span>powered&nbsp;by</span>
        <img src="../images/tipsImg.png">

      </div>
    </div>
    <sq-logo class="logo--bottom"/>
    <p class="copy-right" v-if="isShowCopyRight">Copyright©上海松鼠云上人工智能技术有限公司.<a href="https://beian.miit.gov.cn/">沪ICP备2022012703号-3</a></p>
  </div>
</template>

<script>
/* eslint-disable */
import { getSign } from '@/pages/uc-web/utils/verify';
import {
  getUAString, getOSInfo,
  getBrowserInfo, getFlashVersion,
  getCookieEnable, getLocalStorageEnable, getUrlVia,
} from '@/pages/uc-web/utils/index';
import api from '@/pages/uc-web/api/api';
import { isApp, jsBridgeForSSAI } from '@/utils/index.js'
import _ from 'lodash';
import {getLogo} from '@/utils/auth'

export default {
    created(){
    // const isMobile = navigator.userAgent.match(/(Android|webOS|iPhone|BlackBerry)/i)
    // if(isMobile){
    //   window.location.href = `${window.location.origin}/uc-mobile/login`
    // }
    console.log(this.$route.query.channel)
     if(this.$route.query.channel === 'Lenovo'){
       this.changeLogo = true
     }
     // 清除本地存储
     localStorage.clear()
  },
  async mounted(){
    if (isApp()) {
      jsBridgeForSSAI("floatButton", {
        visibility: 0, // 1.显示按钮；0不显示
        homeUrl: 'https://jzjx-test.classba.cn/uc-web/center', // 回首页的链接
      });
    }
    // const userInfo = JSON.parse(localStorage.getItem('UCINFO')) || {};
    // await getLogo(userInfo.account_id)
    // const logo = sessionStorage.getItem(`${userInfo.account_id}-ChangeLogoUrl`) || {};
    // this.logoUrl = logo.logoUrl
    const { type } = this.$route.query
    if (type === 'app') {
      this.isShowCopyRight = false
      localStorage.setItem('sourceType', 'app')
    } else if (type && type !== 'app') {
      // 当URL参数明确不是app时，显示底部信息并清除app标记
      this.isShowCopyRight = true
      localStorage.removeItem('sourceType')
    } else {
      // 当URL没有type参数时，检查localStorage中是否保存了app来源
      const sourceType = localStorage.getItem('sourceType')
      this.isShowCopyRight = sourceType === 'app' ? false : true
    }
  },
  data() {
    return {
      isPad: /ipad|android/i.test(navigator.userAgent),
      rules: {
        uname: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      client_params: {}, // 客户端参数
      loginForm: {
        uname: '',
        password: '',
        // time_stamp: '',
      },
      changeLogo:false,
      // require('../images/songshu-logo.png') 松鼠的图标
      logoUrl: '',
      NoGroundUrl: '',
      groundUrl: '',
      isShowCopyRight: false,
    };
  },
  directives: {
    debounce: {
      inserted(el, binding) {
        let timer;
        el.addEventListener('click', () => {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            binding.value();
          }, 400);
        });
      },
    },
  },
  methods: {
    // 提交登录
    submitLogin() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const params = {
            uname: this.loginForm.uname,
            password: this.loginForm.password,
          };
          const isProduction = !window.location.host.includes('test')&&!window.location.host.includes('8080');
          const host = isProduction
                  ? 'https://jzjx.classba.cn/uc-web/homePage'
                  : 'https://jzjx-test.classba.cn/uc-web/homePage'; // 测试环境
          const studyHost = isProduction
                  ? 'https://learn.classba.cn'
                  : 'https://learn.test.classba.cn'; // 测试环境
          const res = await api.LoginData(params);
            if (res.code === 200) {
              const type = res.data.school_type
                this.$toast('登录成功');
                if (Number(res.data.school_use_type) !== 6) {
                  window.location.href = `${studyHost}/index?authKey=${res.data.user_token}`;
                }
                setTimeout(() => {
                  this.$router.push({
                    path: '/uc-web/homePage',
                    query: {
                      action: 'login'
                    }
                  });
                }, 2000);
                localStorage.getItem('schoolType', type) // type==31||type==32||type==33 去往学生中心主界面
                localStorage.setItem('real_name', res.data.real_name);
                localStorage.setItem('account_id', res.data.account_id);
                localStorage.setItem('school_id', res.data.school_id);
                localStorage.setItem('user_token', res.data.user_token);
                localStorage.setItem('school_nature_id', res.data.school_nature_id);
                const UCINFO = {
                  real_name: res.data.real_name,
                  account_id: res.data.account_id,
                  school_id: res.data.school_id,
                  user_token: res.data.user_token,
                  school_nature_id: res.data.school_nature_id,
                  school_type: type,
                  school_use_type: res.data.school_use_type
                }
                localStorage.setItem('UCINFO', JSON.stringify(UCINFO));
              if (isApp()) {
                jsBridgeForSSAI("setData", {
                  key: 'UCINFO',
                  value: UCINFO,
                });
                jsBridgeForSSAI("setData", {
                  key: 'user_token',
                  value: res.data.user_token,
                });
             }
            }else{
              this.$toast(res.msg)
            }
        } else {
          console.log('error submit!');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  width: 100%;
  height: 100vh;
  background: #ffffff;
  overflow: hidden;
  .logo--bottom {
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translate(-50%,0);
  }
  .login-bg img {
    height: 100%;
    flex: 1;
  }
  .login-bg{
    position: relative;
    .logo{
      top: 50px;
      left: 30px;
      position: absolute;
      width: 220px;
      height: 45px;
    }
    .adaptive{
      top: 120px;
      left: 30px;
      font-size: 30px;
      color: #fff;
      position: absolute;
      font-weight: 500;
      &.noImg{
      top: 50px
      }
    }
  }

  .form-wrap {
    // flex: 1;
    height: 100%;
    position: relative;
    margin: 26vh auto;
    font-family: PingFangSC-Semibold, PingFang SC;
    // padding-left: 112px;
    .login-log {
      font-size: 26px;
      font-weight: 600;
      color: #6d7278;
      position: absolute;
      top: -66px;
    }
    .login-user {
      position: absolute;
      top: 19px;
      left: 27px;
      z-index: 99;
       img {
        width: 20px;
        height: 24px;
      }
    }
    .login-pass {
      position: absolute;
      top: 39px;
      left: 28px;
      z-index: 99;
       img {
        width: 20px;
        height: 24px;
      }
    }
    .top {
      margin-top: 20px;
    }
    .login-remind {
      font-size: 14px;
      font-weight: 400;
      color: rgba(17, 31, 44, 0.4);
      margin-top: 26px;
      // padding-left: 30px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 20px;
        margin-left: 8px;
        // width: 20px;
        // height: 24px;

      }
      span{
        color: #A183FF;
      }

    }
  }
  ::v-deep {
    .el-input {
      font-family: PingFangSC-Regular, PingFang SC;
      .el-input__inner {
        width: 360px;
        height: 66px;
        background: #ffffff;
        border-radius: 33px;
        border: 1px solid rgba(138, 123, 201, 0.6);
        font-size: 17px;
        font-weight: 400;
        color: #8b99a9;
        line-height: 66px;
        padding-left: 66px;
      }
    }
    .el-form-item__error {
      font-size: 16px;
      padding-left:28px ;
      padding-top: 10px;
    }
    .el-button {
      width: 360px;
      height: 66px;
      border: none;
      background: linear-gradient(180deg, #bb9fff 0%, #8566ff 100%);
      box-shadow: 0px 2px 6px 0px #b1a2ed;
      border-radius: 48px;
      font-size: 24px;
      font-weight: 500;
      color: #ffffff;
      letter-spacing: 1px;
      margin-top: 25px;
    }
  }
}
</style>
